var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 0.414062C8.00003 1.11026 8.68997 2.15206 9.38743 3.027C10.2856 4.15346 11.3574 5.13753 12.5874 5.88886C13.5088 6.45146 14.6276 6.99153 15.5264 6.99153M8.00003 13.5853C8.00003 12.8891 8.68997 11.8473 9.38743 10.9723C10.2856 9.84593 11.3574 8.8618 12.5874 8.11046C13.5088 7.54786 14.6276 7.0078 15.5264 7.0078M15.5264 6.99966H0.473633",
    stroke: "#0D0D0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroArrowRight);
export default __webpack_public_path__ + "static/media/hero-arrow-right.a84629c2d61f597271e3f55ecfeb9315.svg";
export { ForwardRef as ReactComponent };